import { createSimplePageStrategy } from './simple-page.strategy-helper';

export const InstallationSeoStrategy = createSimplePageStrategy(
  'installation-info',
  'installation',
  '/installation'
);
